export default {
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    closeOnClick: {
        type: Boolean,
        default: undefined
    },
    dataImageUrlField: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataSpriteCssClassField: {
        type: String,
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataUrlField: {
        type: String,
        default: undefined
    },
    dataContentField: {
        type: String,
        default: undefined
    },
    direction: {
        type: String,
        default: undefined
    },
    hoverDelay: {
        type: Number,
        default: undefined
    },
    openOnClick: {
        type: [Boolean, Object],
        default: undefined
    },
    orientation: {
        type: String,
        default: undefined
    },
    popupCollision: {
        type: String,
        default: undefined
    },
    scrollable: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    close: Function,
    open: Function,
    activate: Function,
    deactivate: Function,
    select: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoMenu/MenuProps.js